import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";

export const SERVER_SERVICE_NAME = "minkompetanse";
export const CLIENT_SERVICE_NAME = "minkompetanse-client";

export const getDeploymentEnvironment = (): string =>
  process.env.OTEL_ENVIRONMENT ?? "unknown";

export const getServerResourceAttributes = (): Record<string, string> => ({
  [ATTR_SERVICE_NAME]: SERVER_SERVICE_NAME,
  "deployment.environment": getDeploymentEnvironment(),
});
